"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Exchange = void 0;

var _queue = require("../../../internal/queue");

class Consumer {
  constructor(head) {
    this.head = head;
  }

  shift() {
    if (this.isEmpty()) throw new Error('Cannot shift empty queue');
    const {
      data
    } = this.head.next;
    this.head = this.head.next;
    return data;
  }

  isEmpty() {
    return !this.head.next;
  }

}

class Exchange extends _queue.Queue {
  shift() {
    throw new Error('Unsupported');
  }

  hasRoot() {
    return !!this.head;
  }

  spawnConsumerAtRoot() {
    if (!this.head) throw new Error('You cannot spawn a new consumer after setting calling noMoreConsumers');
    return new Consumer(this.head);
  }

  discardRoot() {
    this.head = null;
  }

}

exports.Exchange = Exchange;